module.exports = __webpack_public_path__ + "images/花筑院子全景_06-3.jpg?v=87c1d7ff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu4/花筑院子全景_06-3.jpg
 ** module id = 79
 ** module chunks = 1 2
 **/